import { render, staticRenderFns } from "./MyCropmarketalaysis.vue?vue&type=template&id=5805f1f8&scoped=true&"
import script from "./MyCropmarketalaysis.vue?vue&type=script&lang=js&"
export * from "./MyCropmarketalaysis.vue?vue&type=script&lang=js&"
import style0 from "./MyCropmarketalaysis.vue?vue&type=style&index=0&id=5805f1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5805f1f8",
  null
  
)

export default component.exports